import { get, patch, post } from '@aiptyg/api-client';
import type {
  AdminAccountDTO,
  AdminAccountListResponseDTO,
  AdminAccountPayload,
} from './types';

export function listAdminAccounts(page = 1, pageSize = 50): Promise<AdminAccountListResponseDTO> {
  const qs = new URLSearchParams();
  qs.set('page', String(page));
  qs.set('page_size', String(pageSize));
  return get<AdminAccountListResponseDTO>(`/v1/admin/admin-accounts?${qs.toString()}`);
}

export function createAdminAccount(payload: AdminAccountPayload): Promise<AdminAccountDTO> {
  return post<AdminAccountDTO>('/v1/admin/admin-accounts', { ...payload });
}

export function updateAdminAccount(id: number, payload: AdminAccountPayload): Promise<AdminAccountDTO> {
  return patch<AdminAccountDTO>(`/v1/admin/admin-accounts/${id}`, { ...payload });
}
